import { DialogProps } from "@mui/material";
import Dialog from "components/DraggableDialog/DraggableDialog";
import RefundBookingListModalInner from "./RefundBookingListModalInner";

export interface RefundBookingListModalProps extends DialogProps {
  bookingIds?: number[];
  refund?: number | null;
  afterRefund?: () => void;
}

function RefundBookingListModal({
  bookingIds,
  afterRefund,
  ...props
}: RefundBookingListModalProps) {
  return (
    <Dialog maxWidth="xs" fullWidth {...props}>
      <RefundBookingListModalInner
        bookingIds={bookingIds}
        afterRefund={afterRefund}
        {...props}
      />
    </Dialog>
  );
}

export default RefundBookingListModal;
